/*
  Le reserva lugar a lo que va DEBAJO de la foto en la ficha de producto.

  El tema calcula el alto de la foto con max(min, 100vh - --viewport-offset) y no
  sabe nada de lo que viene abajo: la tira de miniaturas y, si hay combinacion
  elegida, la tira de fotos que agrega el selector de colores. Sin esto la suma se
  pasa del alto de la ventana y esas tiras terminan pisando la foto o quedando
  abajo del borde, sin forma de llegar (la columna ya no tiene scroll propio).

  Lo que se hace es despejar el offset que deja la foto en el alto maximo que
  entra. NO alcanza con sumarle al offset lo que falta: mientras el ancho es el
  que limita a la foto, su alto no depende del offset para nada.

  Nota para el proximo que lo toque: no atar el ANCHO de la tira al de la foto.
  Se probo el 2026-09-16 y abre un circulo (ancho de foto -> ancho de fila ->
  tamano de miniatura -> alto de fila -> cuanto ceder -> alto de foto), que no
  cierra y termina con la fila encima de la foto.
*/
(function () {
  'use strict';

  var COL = '.sf-media-fija';
  var FOTO = '.product-media-container';

  // El ancho se fija con la foto PRINCIPAL, no con la que se este mirando.
  // La tira de miniaturas es una grilla: sus columnas se reparten el ancho de la
  // fila, asi que si la fila cambia con cada foto, TODAS las miniaturas cambian
  // de tamano. Y como el tema les pone transition: all, el cambio se anima y se
  // ve como que las miniaturas se pisan y saltan. El cliente lo reporto el
  // 2026-09-16. Ademas el pidio alinear "al ancho de la foto principal", que es
  // justamente esto.
  // Manda la foto PRINCIPAL (la primera), no la que se este mirando. Mientras la
  // principal no se haya mostrado se usa la que haya y se corrige en cuanto
  // aparece. No se guarda "el mas grande visto": durante la carga hay medidas
  // provisorias mas anchas que la definitiva y se quedaban pegadas.
  // El selector de colores agrega una tira con las fotos de la combinacion
  // ADENTRO del mismo item que la foto. El tema calcula el alto de la foto con
  // max(min, 100vh - --viewport-offset) y no sabe nada de esa tira, asi que la
  // tira terminaba abajo del borde de la ventana. Antes se alcanzaba con el
  // scroll propio de la columna, pero ese scroll es justamente lo que se saco.
  // Se le suma el alto de la tira al offset del tema para que la foto ceda ese
  // espacio. Se guarda el valor original una sola vez por contenedor.
  var BASE = 'data-sf-offset-base';
  var SEPARACION = 16;   // el aire entre la foto y la tira

  // Solo de 750px para arriba, igual que el CSS. En el celular la columna no va
  // fija y la pagina scrollea normal, asi que no hay nada que reservar: tocarlo
  // ahi solo achicaba la foto sin motivo.
  var ESCRITORIO = '(min-width: 750px)';

  function ajustar() {
    var galerias = document.querySelectorAll(COL + ' media-gallery');
    for (var i = 0; i < galerias.length; i++) {
    }
  }

  // El observador y el ajuste se pisan: al medir hay que sacar y reponer
  // --viewport-offset, y esas dos escrituras son mutaciones de estilo que el
  // propio observador vuelve a leer. Sin esta bandera queda dando vueltas para
  // siempre y le come el 100% de un nucleo al navegador del visitante.
  var mo = null;
  var ocupado = false;

  var QUE_MIRAR = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden']
  };

  function ajustarConCuidado() {
    if (ocupado) return;
    ocupado = true;
    if (mo) mo.disconnect();
    try {
      ajustar();
    } finally {
      if (mo) {
        mo.takeRecords();                 // tirar lo que genere yo mismo
        var col = document.querySelector(COL);
        if (col) mo.observe(col, QUE_MIRAR);
      }
      // recien se suelta despues de que el navegador acomode el layout, para no
      // reentrar por el ResizeObserver con el cambio propio
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () { ocupado = false; });
      } else {
        setTimeout(function () { ocupado = false; }, 0);
      }
    }
  }

  // Las miniaturas de las variantes que no se estan mostrando quedan en
  // display:none, y una imagen escondida NO se descarga aunque se le ponga
  // loading="eager" (probado). Entonces, al cambiar entre Simil y Personalizado,
  // la miniatura recien ahi sale a buscar su archivo y se queda en blanco un
  // rato, mientras que la foto grande ya cambio. Eso es lo que se ve como que
  // "la primera de abajo tarda en cambiar".
  // Aca se le da un empujon: se piden de antemano, al mismo ancho que el
  // navegador eligio para las que si se ven, para que cuando toquen quedarse
  // visibles ya esten en la cache.
  function calentarMiniaturas() {
    var imgs = document.querySelectorAll(COL + ' .thumbnail-list__item img');
    if (!imgs.length) return;

    var ancho = null;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].naturalWidth && imgs[i].currentSrc) {
        var m = imgs[i].currentSrc.match(/[?&]width=(\d+)/);
        if (m) { ancho = m[1]; break; }
      }
    }
    if (!ancho) return;                       // todavia no cargo ninguna

    for (var j = 0; j < imgs.length; j++) {
      if (imgs[j].naturalWidth) continue;      // esa ya esta
      if (imgs[j].dataset.sfCalentada === '1') continue;
      var u = imgs[j].getAttribute('src');
      if (!u) continue;
      imgs[j].dataset.sfCalentada = '1';
      u = u.replace(/([?&]width=)\d+/, '$1' + ancho);
      if (u.indexOf('//') === 0) u = window.location.protocol + u;
      var pre = new Image();
      pre.src = u;                             // solo para dejarla en la cache
    }
  }

  function arrancar() {
    var col = document.querySelector(COL);
    if (!col) return;                             // no es una ficha con foto fija

    ajustar();

    // la foto cambia de tamano al mover la ventana y al cambiar de variante
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(ajustarConCuidado);
      ro.observe(col);
      var foto = col.querySelector(FOTO);
      if (foto) ro.observe(foto);
    } else {
      window.addEventListener('resize', ajustarConCuidado);
    }

    // al cambiar de variante el tema no reemplaza nodos, les cambia clases y
    // estilos, asi que childList solo no alcanza.
    mo = new MutationObserver(ajustarConCuidado);
    mo.observe(col, QUE_MIRAR);

    // las imagenes cambian de tamano recien cuando cargan
    // Repasos con reloj. El selector de colores inyecta su tira DESPUES, y si la
    // unica corrida util cayo antes de eso, la cuenta se hace sin ella y no se
    // recorta nada. El observador deberia agarrarlo, pero depende de cuando se
    // engancho. Estos repasos son baratos y cierran esa ventana.
    [300, 900, 1800, 3000].forEach(function (ms) {
      setTimeout(ajustarConCuidado, ms);
    });

    window.addEventListener('load', function () {
      ajustarConCuidado();
      // despues de que la pagina termino, sin robarle ancho de banda al inicio
      if (window.requestIdleCallback) window.requestIdleCallback(calentarMiniaturas, { timeout: 3000 });
      else setTimeout(calentarMiniaturas, 1200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
